import clsx from 'clsx'
import { toOptions } from 'components/QuestionnaireRequestAutomated/utilities/processor'
import React, { useId, useRef } from 'react'

export const Checkbox = ({ label, checked = false, onChange, inputClasses = null, labelClasses = null, ...props }) => {
  const id = useId()
  return (
    <div className="dome-d-flex dome-align-center dome-gap6">
      <input
        id={id}
        style={{ margin: 0 }}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className={clsx(inputClasses)}
        {...props}
      />
      <label style={{ textWrap: 'nowrap' }} className={clsx(labelClasses || 'dome-text-w400')} htmlFor={id}>
        {label}
      </label>
    </div>
  )
}

export const RadioCheckbox = ({ label, labelClasses, checked = false, onChange, ...props }) => {
  const id = useId()
  const inputRef = useRef(null)

  return (
    <div className="dome-d-flex dome-align-center dome-gap6">
      <div onClick={() => inputRef.current.click()} className="radio-checkbox-container">
        <span aria-checked={checked} className="custom-radio"></span>
        <input ref={inputRef} id={id} type="checkbox" className="hidden-checkbox" onChange={onChange} {...props} />
      </div>
      {label && (
        <label htmlFor={id} className={clsx('dome-p2 dome-color-med-grey dome-cursor-pointer', labelClasses)}>
          {label}
        </label>
      )}
    </div>
  )
}

export const OptionsField = (props) => {
  const { field, options, id, value, onChange, isSkipNa, isOpacity, endIcon } = props
  const select_options = toOptions(options || field.options, isSkipNa)

  return (
    <div style={{ opacity: isOpacity ? 0.4 : 1 }} className="dome-d-flex dome-align-end dome-justify-between">
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto auto',
          gap: 18,
          rowGap: 0,
        }}
      >
        {select_options.map(([valueOption, label]) => (
          <div key={label} style={{ padding: '3px 6px' }}>
            <RadioCheckbox
              label={label}
              checked={valueOption === value}
              onChange={() => onChange({ [id]: valueOption })}
            />
          </div>
        ))}
      </div>
      {endIcon}
    </div>
  )
}
